import { ObservabilityToolType } from 'types/api/status-checks/status-check'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const DATADOG_MONITOR_PAGE_URLS = {
  datadog: 'https://app.datadoghq.com/monitors',
  datadog_us3: 'https://us3.datadoghq.com/monitors',
  datadog_us5: 'https://us5.datadoghq.com/monitors',
  datadog_eu: 'https://app.datadoghq.eu/monitors',
  datadog_us1_fed: 'https://app.ddog-gov.com/monitors'
}

export const ENDPOINT_URLS = {
  datadog: 'https://app.datadoghq.com/api/',
  datadog_us3: 'https://us3.datadoghq.com/api/',
  datadog_us5: 'https://us5.datadoghq.com/api/',
  datadog_eu: 'https://app.datadoghq.eu/api/',
  datadog_us1_fed: 'https://app.ddog-gov.com/api/',
  newrelic: 'https://api.newrelic.com/',
  pagerduty: 'https://api.pagerduty.com/',
  k6: 'https://api.k6.io/'
}

export const PAGERDUTY_ABILITIES_PATH = 'abilities'

export const NEWRELIC_ALERTS_INCIDENTS_PATH = 'v2/alerts_incidents.json'

export const ADDITIONAL_KNOWN_URLS = {
  datadog: ['https://api.datadoghq.com/api/'],
  datadog_eu: ['https://api.datadoghq.eu/api/']
}

// Integrations which have special formats that are derived from regex patterns.
export const DOMAIN_NAME_INTEGRATIONS: Set<IntegrationType> = new Set([
  IntegrationType.Grafana,
  IntegrationType.Dynatrace,
  IntegrationType.Appdynamics
])

// Integrations which should reference the 'url' field of the integration in all cases.
export const URL_INTEGRATIONS: Set<IntegrationType> = new Set([
  IntegrationType.AWS,
  IntegrationType.Custom,
  IntegrationType.Prometheus
])

// Integrations which should reference the 'url' field only when connecting to a private network.
export const URL_INTEGRATIONS_PNI: Set<IntegrationType> = new Set([
  IntegrationType.Grafana,
  IntegrationType.Prometheus
])

// Integrations which utilize the alternate `authenticationUrl` field instead of the `apiBaseUrl` field.
export const AUTHENTICATION_URL_INTEGRATIONS: Set<IntegrationType> = new Set([
  IntegrationType.AWS,
  IntegrationType.Custom,
  IntegrationType.Prometheus
])

// Observability tools that support private network integration
export const PRIVATE_NETWORK_INTEGRATION_OBSERVABILITY_TOOLS: Set<ObservabilityToolType> =
  new Set([
    ObservabilityToolType.APPDYNAMICS,
    ObservabilityToolType.CUSTOM,
    ObservabilityToolType.DYNATRACE,
    ObservabilityToolType.GRAFANA,
    ObservabilityToolType.PROMETHEUS,
    // A business decision was made to also include NEWRELIC and PAGERDUTY to simplify form logic, though they may not support self-hosted deployments where PNI would apply.
    ObservabilityToolType.NEWRELIC,
    ObservabilityToolType.PAGERDUTY
  ])
